<template>
  <div
    class="fixed top-0 left-0 w-screen h-screen z-[100001] opacity-0 pointer-events-none transition-all duration-500"
    :class="{ 'opacity-100 pointer-events-auto': modalsStore.isContinueModalVisible }">
    <div
      class="absolute top-0 left-0 w-full h-full z-10 opacity-70 bg-black backdrop-blur-lg"
      @click="modalsStore.hideContinueModal"></div>
    <div
      class="absolute inset-0 z-20 flex items-center justify-center p-5 pointer-events-none">
      <div
        class="relative w-full max-w-xl max-h-full scale-0 overflow-y-auto rounded-2xl bg-white pointer-events-auto transition-all duration-500"
        :class="{ 'scale-100': modalsStore.isContinueModalVisible }">
        <div class="w-full p-6 flex flex-col items-center justify-center gap-4">
          <div
            class="modal-message w-full p-3 bg-blue text-white text-center rounded-lg"
            v-html="modalsStore.continueModalMessage"></div>
          <div class="w-full flex items-center justify-center gap-4">
            <button
              class="w-44 h-9 flex items-center justify-center cursor-pointer rounded bg-red hover:bg-dark-red text-white tr-all"
              @click="modalsStore.incrementContinueModalConfirmCounter">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useModalsStore from '@/store/modals';

const modalsStore = useModalsStore();
</script>
